var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1400",
    "data-name": "Group 1400",
    transform: "translate(-929 -901.467)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_01",
    "data-name": 1,
    transform: "translate(-9676.479 -2212.64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M10623.933,3117.412a3.79,3.79,0,0,0-2.656-1.105h-9.581a3.446,3.446,0,0,0-3.785,3.786v11.954a1.392,1.392,0,0,0,2.23,1.116l1.363-1.02a.2.2,0,0,1,.268.02l1.324,1.331a1.4,1.4,0,0,0,1.979,0l1.338-1.339a.2.2,0,0,1,.256-.016l1.362,1.02a1.394,1.394,0,0,0,2.231-1.116v-7.372h2.132a2.508,2.508,0,0,0,2.649-2.359,2.411,2.411,0,0,0,0-.291v-1.932a3.791,3.791,0,0,0-1.111-2.681Zm-4.657.177a1.981,1.981,0,0,0-.1.257c-.019.061-.042.119-.055.182a2.14,2.14,0,0,0-.053.439c0,.011,0,.021,0,.032v13.548a.19.19,0,0,1-.11.178.194.194,0,0,1-.209-.019l-1.355-1.015a1.388,1.388,0,0,0-1.822.123l-1.339,1.339a.2.2,0,0,1-.144.059h0a.2.2,0,0,1-.143-.059l-1.325-1.33a1.409,1.409,0,0,0-1.833-.134l-1.363,1.02a.187.187,0,0,1-.207.02.2.2,0,0,1-.109-.182v-11.954a2.258,2.258,0,0,1,2.59-2.59h7.611c-.013.027-.019.058-.031.086Zm4.573,4.436a1.324,1.324,0,0,1-1.179,1.455,1.4,1.4,0,0,1-.275,0h-2.132v-4.974a1.007,1.007,0,0,1,1-1,2.585,2.585,0,0,1,2.578,2.59Zm-10.359,3.653a.6.6,0,0,1,.6-.6h2.391a.6.6,0,1,1,0,1.195h-2.391A.6.6,0,0,1,10613.489,3125.678Zm0-3.188a.6.6,0,0,1,.6-.6h2.391a.6.6,0,1,1,0,1.2h-2.391A.6.6,0,0,1,10613.489,3122.49Zm-1.818-.8a.8.8,0,1,1-.8.8A.8.8,0,0,1,10611.671,3121.693Zm.8,3.985a.8.8,0,1,1-.8-.8A.8.8,0,0,1,10612.468,3125.678Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_571",
    "data-name": "Rectangle 571",
    width: 22,
    height: 22,
    transform: "translate(929 901.467)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBilling);
export default __webpack_public_path__ + "static/media/icon-billing.fbe7bf47e6607d68897c00c5de0c67df.svg";
export { ForwardRef as ReactComponent };